import { render, staticRenderFns } from "./tUser.vue?vue&type=template&id=ff6ede42&scoped=true"
import script from "./tUser.vue?vue&type=script&lang=js"
export * from "./tUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ede42",
  null
  
)

export default component.exports